import type { InviteResult } from './api'

// What the last Send questionnaire answered, kept for the one screen that
// shows it next: the vendor's own page.
//
// # WHY THE VENDOR PAGE AND NOT A PAGE OF ITS OWN
//
// After "Send now" the person was put on a "Sent" page whose primary button was
// Back to Home, and Home then showed the same questionnaire again in four
// widgets (release 3.2, removal item 6; flow F1 in the duplication map). A send
// that went now lands on the vendor, with the confirmation at the top and the
// Next step bar saying what happens next. A send that did not go (mail muted,
// held for a second person) keeps its own page, because that page says what to
// do and it is long.
//
// Held in memory for one read, so a reload or a later visit does not show a
// confirmation for something sent an hour ago.

let last: { vendorId: string; sent: InviteResult } | null = null

export function rememberSent(vendorId: string, sent: InviteResult) {
  last = { vendorId, sent }
}

export function takeSent(vendorId: string): InviteResult | null {
  if (!last || last.vendorId !== vendorId) return null
  const s = last.sent
  last = null
  return s
}
